import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ErrorHandler, Injector, NgModule, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { TitleStrategy } from '@angular/router';
import { PageTitleStrategy } from './services/page-title.strategy';

import { AppComponent } from './app.component';
import { AppInfoService } from './shared/services';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './utilities/auth.interceptor';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { AppLoadService } from './services';
import { AppBoostrapService } from './services/app-boostrap.service';

export function initializeApp(injector: Injector) {
  return (): Promise<boolean> => {
    const appInitService = injector.get(AppLoadService);
    return appInitService.initAppWithKinde();
  };
}

export function bootstrapListener(injector: Injector) {
  return () => {
    const appInitService = injector.get(AppBoostrapService);
    return appInitService.bootstrap();
  };
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        ToastContainerComponent,
        ConfirmDialogComponent,
        AppRoutingModule], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [Injector],
            multi: true
        },
        {
            provide: APP_BOOTSTRAP_LISTENER,
            useFactory: bootstrapListener,
            deps: [Injector],
            multi: true
        },
        AppInfoService,
        {
            provide: TitleStrategy,
            useClass: PageTitleStrategy,
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({ showDialog: false }),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN'
        }))
    ] })
// skipcq: JS-0327
export class AppModule { }
